/* ============================================================
   YIOSI LAMPS · interaction layer
   Every data-action="name" in the sections maps to a handler here.
   Pure vanilla, no dependencies. Cart calls use Shopify AJAX API.

   IMPORTANT: every Milan section emits its own <script src> tag for
   this file, and classic scripts execute once PER TAG — on the
   homepage that used to mean ~20 executions, 20 click delegates and
   20 add-to-carts per click. Document-level singletons are therefore
   guarded by window.__yiosiMilanInit, and element bindings live in an
   idempotent run() (data-flag guarded) that is safe to call from
   every duplicate execution and from shopify:section:load re-renders
   in the theme editor.
   ============================================================ */
(function () {
  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* ================= document-level singletons ================= */
  if (!window.__yiosiMilanInit) {
    window.__yiosiMilanInit = true;

    /* ---- scroll progress + sticky nav compression ---- */
    const onScroll = () => {
      const bar = $('[data-progress]'), nav = $('[data-navbar]');
      const d = document.scrollingElement || document.documentElement;
      const h = d.scrollHeight - d.clientHeight, y = d.scrollTop || window.scrollY || 0;
      if (bar) bar.style.width = (h > 0 ? Math.min(1, y / h) * 100 : 0) + '%';
      if (nav) { const t = y > 60; nav.style.paddingTop = nav.style.paddingBottom = t ? '11px' : '17px'; }
    };
    addEventListener('scroll', onScroll, { passive: true }); onScroll();

    /* ---- section reveal ---- */
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => es.forEach(e => {
        if (e.isIntersecting) { e.target.style.opacity = 1; e.target.style.transform = 'none'; io.unobserve(e.target); }
      }), { rootMargin: '0px 0px -8% 0px' });
      $$('main > .shopify-section').forEach(s => {
        s.style.cssText += ';opacity:0;transform:translateY(18px);transition:opacity 720ms ease,transform 720ms cubic-bezier(.22,.61,.36,1);';
        io.observe(s);
      });
    }

    /* ---- overlay pages: menu / cart / product / category ---- */
    const open  = sel => { const el = $(sel); if (el) el.hidden = false; };
    const close = sel => { const el = $(sel); if (el) el.hidden = true; };
    const map = {
      toggleMenu: () => { const m = $('[data-overlay="menu"]'); if (m) m.hidden = !m.hidden; },
      closeMenu:  () => close('[data-overlay="menu"]'),
      openCart:   () => open('[data-overlay="cart"]'),
      closeCart:  () => close('[data-overlay="cart"]'),
      closeQuick: () => close('[data-overlay="product"]'),
      closeCat:   () => close('[data-overlay="category"]'),
      openCatCeiling: () => location.assign('/collections/ceiling-lights'),
      openCatSconce:  () => location.assign('/collections/wall-sconces'),
      openCatLamp:    () => location.assign('/collections/table-floor-lamps')
    };
    document.addEventListener('click', e => {
      const t = e.target.closest('[data-action]'); if (!t) return;
      const name = t.dataset.action;
      if (map[name]) { e.preventDefault(); map[name](); return; }
      if (/^(add|p\.add|addSofa|addQuick|addRoom)$/.test(name)) { e.preventDefault(); addToCart(t); }
    });

    /* ---- Shopify AJAX cart ---- */
    async function addToCart(el) {
      const id = el.dataset.variantId; if (!id) return;
      if (el.dataset.busy) return; el.dataset.busy = '1';   // no double-adds on double-click
      try {
        await fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) });
        const c = await (await fetch('/cart.js')).json();
        $$('[data-cart-count]').forEach(n => n.textContent = c.item_count);
        if (document.querySelector('[data-overlay="cart"]')) { open('[data-overlay="cart"]'); } else { location.assign('/cart'); }
      } finally { delete el.dataset.busy; }
    }

    /* re-wire element bindings when the theme editor re-renders a section */
    document.addEventListener('shopify:section:load', () => run());
  }

  /* ================= idempotent element bindings ================= */
  function run() {
    /* ---- FAQ accordion ---- */
    $$('[data-faq-toggle]:not([data-yi-faq])').forEach(q => {
      q.setAttribute('data-yi-faq', '1');
      q.addEventListener('click', () => {
        const panel = q.nextElementSibling, sign = q.querySelector('[data-faq-sign]');
        const openNow = panel.hidden;
        panel.hidden = !openNow; if (sign) sign.textContent = openNow ? '−' : '+';
      });
    });

    /* ---- autoplay muted hero video ---- */
    $$('video:not([data-yi-vid])').forEach(v => {
      v.setAttribute('data-yi-vid', '1');
      v.muted = true; const p = v.play(); if (p && p.catch) p.catch(() => {});
    });

    /* ---- variant picker ----
       Contract: a [data-variants] wrapper holding a JSON list of
       {id, options:[…], available, price, image} plus option buttons
       [data-opt-value] grouped by [data-opt-index]. Selecting a value
       resolves the matching variant and updates the price, the main
       image and the add-to-cart button's data-variant-id. Nothing here
       assumes a particular section — any Milan section can use it. */
    $$('[data-variants]:not([data-yi-var])').forEach(root => {
      root.setAttribute('data-yi-var', '1');
      let variants = [];
      try { variants = JSON.parse(root.getAttribute('data-variants') || '[]'); } catch (e) { return; }
      if (!variants.length) return;

      const groups = $$('[data-opt-index]', root);
      const btn    = root.querySelector('[data-action="p.add"]') ||
                     document.querySelector('[data-variant-target="' + root.id + '"]');
      const priceEl = root.querySelector('[data-variant-price]');
      const imgEl   = document.querySelector('[data-variant-image="' + root.id + '"]');

      /* a hand-picked cover stays until the shopper actually chooses a variant */
      let touched = false;
      const chosen = () => groups.map(g => {
        const on = g.querySelector('[data-opt-value][aria-pressed="true"]');
        return on ? on.getAttribute('data-opt-value') : null;
      });

      const paint = () => {
        const sel = chosen();
        const match = variants.find(v => v.options.every((o, i) => sel[i] == null || o === sel[i]));
        // grey out values that cannot combine with the rest of the selection
        groups.forEach((g, gi) => {
          $$('[data-opt-value]', g).forEach(b => {
            const val = b.getAttribute('data-opt-value');
            const test = sel.slice(); test[gi] = val;
            const can = variants.some(v => v.available && v.options.every((o, i) => test[i] == null || o === test[i]));
            b.disabled = !can;
            b.style.opacity = can ? '' : '0.32';
          });
        });
        if (!match) return;
        if (priceEl) priceEl.textContent = match.price;
        if (imgEl && match.image && (touched || !imgEl.hasAttribute('data-cover-locked'))) imgEl.src = match.image;
        if (btn) {
          btn.dataset.variantId = match.id;
          btn.disabled = !match.available;
          btn.style.opacity = match.available ? '' : '0.45';
          btn.style.cursor = match.available ? 'pointer' : 'default';
          if (btn.dataset.labelSold) btn.textContent = match.available ? btn.dataset.labelAdd : btn.dataset.labelSold;
        }
      };

      groups.forEach(g => {
        $$('[data-opt-value]', g).forEach(b => b.addEventListener('click', e => {
          e.preventDefault();
          if (b.disabled) return;
          $$('[data-opt-value]', g).forEach(o => o.setAttribute('aria-pressed', 'false'));
          b.setAttribute('aria-pressed', 'true');
          touched = true;
          paint();
        }));
      });
      paint();
    });

    /* ---- shop-the-room hotspots: highlight without the page jump ----
       The markers are plain anchors so they still work without JS, but the
       native #fragment navigation yanks the page. Intercept: highlight the
       row, and only scroll if it is off-screen (smooth, nearest). */
    $$('[data-spot]:not([data-yi-spot])').forEach(spot => {
      spot.setAttribute('data-yi-spot', '1');
      spot.addEventListener('click', e => {
        const href = spot.getAttribute('href') || '';
        if (!href.startsWith('#')) return;
        const row = document.getElementById(href.slice(1));
        if (!row) return;
        e.preventDefault();
        const scope = row.closest('[data-room]') || document;
        $$('[data-row]', scope).forEach(r => r.removeAttribute('data-active'));
        row.setAttribute('data-active', '');
        row.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        clearTimeout(row._yiHl);
        row._yiHl = setTimeout(() => row.removeAttribute('data-active'), 2600);
      });
    });

    /* ---- carousel rail: arrows + brass progress line ----
       Contract: a [data-rail] wrapper containing [data-rail-track]
       (the overflow-x:auto flex), optional [data-rail-prev] /
       [data-rail-next] buttons and a [data-rail-bar]>[data-rail-thumb]
       progress line. Everything hides itself when nothing overflows. */
    $$('[data-rail]:not([data-yi-rail])').forEach(rail => {
      rail.setAttribute('data-yi-rail', '1');
      const track = rail.querySelector('[data-rail-track]');
      if (!track) return;
      const prev = rail.querySelector('[data-rail-prev]');
      const next = rail.querySelector('[data-rail-next]');
      const bar = rail.querySelector('[data-rail-bar]');
      const thumb = rail.querySelector('[data-rail-thumb]');

      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        const over = max > 16;
        [prev, next].forEach(b => { if (b) b.style.display = over ? '' : 'none'; });
        if (bar) bar.style.display = over ? '' : 'none';
        if (!over) return;
        const x = track.scrollLeft;
        if (prev) prev.disabled = x <= 2;
        if (next) next.disabled = x >= max - 2;
        if (thumb && bar) {
          const w = track.clientWidth / track.scrollWidth;
          thumb.style.width = (w * 100) + '%';
          thumb.style.transform = 'translateX(' + (x / max * (1 - w) * 100 / w) + '%)';
        }
      };
      /* Desktop arrows fight `scroll-snap-type:x mandatory`: the last card's
         snap start can exceed the max scroll offset, so Chrome bounces a
         smooth scroll straight back. Where arrows are the affordance
         (>=750px) we drop snapping on this track; mobile keeps swipe snap. */
      const mq = matchMedia('(min-width: 750px)');
      const applySnap = () => { track.style.scrollSnapType = (mq.matches && (prev || next)) ? 'none' : ''; };
      applySnap();
      if (mq.addEventListener) mq.addEventListener('change', applySnap);
      const step = dir => {
        const max = track.scrollWidth - track.clientWidth;
        const target = Math.max(0, Math.min(max, track.scrollLeft + dir * track.clientWidth * 0.85));
        track.scrollTo({ left: target, behavior: 'smooth' });
      };
      /* Desktop had no way to move the rail except the arrows: the scrollbar is
         hidden and a mouse has no horizontal wheel. Add press-and-drag, mouse
         only — touch already pans natively, and hijacking it would fight the
         browser's own momentum scrolling. */
      if (!track.hasAttribute('data-yi-drag')) {
        track.setAttribute('data-yi-drag', '1');
        let dragging = false, startX = 0, startLeft = 0, moved = 0, pid = null;
        track.style.cursor = 'grab';
        track.addEventListener('pointerdown', e => {
          if (e.pointerType !== 'mouse' || e.button !== 0) return;
          if (track.scrollWidth - track.clientWidth <= 16) return;
          dragging = true; moved = 0; pid = e.pointerId;
          startX = e.clientX; startLeft = track.scrollLeft;
          track.style.cursor = 'grabbing';
          track.style.scrollSnapType = 'none';
        });
        track.addEventListener('pointermove', e => {
          if (!dragging || e.pointerId !== pid) return;
          const dx = e.clientX - startX;
          if (Math.abs(dx) > 3) {
            /* scroll first: pointer capture can throw (synthetic events, exotic
               input) and must never be what stops the drag from working */
            moved = Math.max(moved, Math.abs(dx));
            track.scrollLeft = startLeft - dx;
            e.preventDefault();
            try { if (!track.hasPointerCapture(pid)) track.setPointerCapture(pid); } catch (err) {}
          }
        });
        const endDrag = e => {
          if (!dragging) return;
          dragging = false;
          track.style.cursor = 'grab';
          try { if (pid !== null && track.hasPointerCapture(pid)) track.releasePointerCapture(pid); } catch (err) {}
          pid = null;
          applySnap();
        };
        track.addEventListener('pointerup', endDrag);
        track.addEventListener('pointercancel', endDrag);
        /* a drag that ended over a card must not also open that card */
        track.addEventListener('click', e => { if (moved > 5) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
      }
      if (prev) prev.addEventListener('click', () => step(-1));
      if (next) next.addEventListener('click', () => step(1));
      track.addEventListener('scroll', update, { passive: true });
      addEventListener('resize', update, { passive: true });
      update();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
})();
